import React, { useState } from "react";

import Banner from "../assets/images/hero.png";
import namaste from "../assets/images/namaste.svg";
import SearchIconLight from "../assets/images/searchlight.svg";
import cityIcon from "../assets/images/city.svg";
import hotelIcon from "../assets/images/hotel.svg";
import guideIcon from "../assets/images/guide.svg";
import location from "../assets/images/location.svg";
import profile from '../assets/images/mobilefooter/profile.png'
import Location from '../assets/images/card/4.png'
import logo from '../assets/images/logo/logo.png'


import Navbar from "../layout/Navbar";
import HomeSearch from "../components/elements/HomeSearch";
import PropertyCard from "../components/cards/PropertyCard";
import BlogCard from "../components/cards/BlogCard";
import GuideCard from "../components/cards/GuideCard";
import OfferCard from "../components/cards/OfferCard";
import useWidth from "../hooks/useWidth";

import GuideCardMobile from "../components/cards/mobileView/GuideCard";
import * as apis from '../apis'
import { useFetch } from "../hooks/useFetch";

import { Link, useNavigate } from "react-router-dom";
import AccommodationCard from "../components/cards/mobileView/AccommodationCard";

import TrendingCard from "../components/cards/TrendingCard";
import { useSelector } from "react-redux";
import LoginPopup from "../components/LoginPopup";
import ImageSlider from "../components/elements/ImageSlider";
import { SwiperSlide } from "swiper/react";
import Loader from "../components/elements/Loader";
import Icon from "../components/Icon";
import { faSearch, faXmark } from "@fortawesome/free-solid-svg-icons";
import SearchCapsules from "../components/elements/SearchCapsules";


const HomePage = () => {
  const width = useWidth();
  const [modal, setModal] = useState({ open: false });
  const [activeLink, setActiveLink] = useState("search_all")
  const [search, setSearch] = useState({ tag: "search_all", search: null })
  const [ loading, setLoading ] = useState(false)

  const [locations] = useFetch(apis.getAllCities, [])
  const [ hotels, setHotels, hotelloading ] = useFetch(apis.getTopHotel, [], "Mathura")
  const [ guides, setGuides ] = useFetch(apis.getGuides, [])
  const [blogs, setBlogs] = useFetch(apis.recentBlogs, [])
  const [upcomingToursAndEvents] = useFetch(apis.upcomingToursAndEvents, [])
  const [propertyType] = useFetch(apis.allPropertTypes, [])

  const isLoggedIn = useSelector( state => state.auth.isLoggedIn )
  const navigate = useNavigate()

  const hotels_breakpoints = {
    320: {
      slidesPerView: 1,
    },
    350: {
      slidesPerView: 1.2,
    },
    425: {
      slidesPerView: 1.3
    },
    768: {
      slidesPerView: 2.5,
    },
    1024: {
      slidesPerView: 2.5,
    },
    1280: {
      slidesPerView: 3
    },
    1440: {
      slidesPerView: 3.5
    }
  };



  const handleLogin = () => {
      if( isLoggedIn ){
        navigate('/user')
        return
      }
      setModal({ open: true })
  }

  const homesearch = async ( search ) => {
    try {
      setLoading(true)
      const response = await apis.homeSearch(search)
      setHotels(response.users)
      setGuides(response.guides)
      setBlogs(response.blogs)
      setSearch(search)
      setTimeout(() => {
        setLoading(false)
      }, 500)
      
      if( search.search ){
        window.scroll({ top: window.screen.availHeight, behaviour: "smooth" })
      }
    } catch (error) {
      
    }
  }

  return (
    <>
      <Loader loading={loading || hotelloading  } />
      <Navbar />
      {width < 992 && <>

        <div className={`mobile-header gradient`} style={{zIndex:"2"}} >
          <div className="header-main-content  d-flex flex-column justify-content-between">
            <div className="d-flex  justify-content-between align-items-center px-3 py-4">
              <div className="mobile-logo-container">
                <img src={logo} alt="" className="w-100 h-100" />
              </div>
                <div className="basket p-1" onClick={() => handleLogin()}>
                  <img src={profile} alt="" className="basket-img" />
                </div>
            </div>
          
          
          </div>
        </div>
        
      </>}
      <div className="hero-section " style={{zIndex:"1"}}>
        <img src={Banner} className="w-100 h-100 hero-img bg-backdrop" alt="" />
        <div
          className=" hero-inner d-flex justify-content-center  flex-column"
          style={{ position: "relative", width: "100vw" }}
        >
          <div className="d-flex flex-column justify-content-center align-items-center">
            <img src={namaste} alt="" />
            <div className="namaste mt-3">Book Hotel,</div>
            <div className="namaste">Guides & More</div>
          </div>
          <div className="d-flex w-100 justify-content-center">
            <div className="d-flex  w-100 flex-column mt-4">
              <div className="w-100 d-flex justify-content-center overflow-auto">
                <ul className="list-unstyled d-flex gap-4">
                  <li className={`cursor-pointer pb-2 ${ activeLink === "search_all" ? "border-bottom border-3 border-warning" : "" }`} onClick={() => setActiveLink("search_all")}>
                    <div className="d-flex gap-2 align-items-center">
                        <img className="search-text-img" src={SearchIconLight} alt="" />
                        <p className="mb-0 search-text">Search All</p>
                    </div>
                  </li>

                  <li className={`cursor-pointer pb-2 ${ activeLink === "hotel" ? "border-bottom border-3 border-warning" : "" }`} onClick={() => setActiveLink("hotel")}>
                    <div className="d-flex gap-2 align-items-center">
                        <img className="search-text-img" src={hotelIcon} alt="" />
                        <p className="mb-0 search-text">Hotel</p>
                    </div>
                  </li>

                  <li className={`cursor-pointer pb-2 ${ activeLink === "city" ? "border-bottom border-3 border-warning" : "" }`} onClick={() => setActiveLink("city")}>
                    <div className="d-flex gap-2 align-items-center">
                        <img className="search-text-img" src={cityIcon} alt="" />
                        <p className="mb-0 search-text">City</p>
                    </div>
                  </li>

                  <li className={`cursor-pointer pb-2 ${ activeLink === "guide" ? "border-bottom border-3 border-warning" : "" }`} onClick={() => setActiveLink("guide")}>
                    <div className="d-flex gap-2 align-items-center">
                        <img className="search-text-img" src={guideIcon} alt="" />
                        <p className="mb-0 search-text">Guide</p>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="w-100 d-flex justify-content-center">
                <HomeSearch onSearch={ v => homesearch({ tag: activeLink, search: v })} />
              </div>

              <div className="mt-5" style={{ paddingBottom: width < 992 && "3rem"}} >
                <h4 className="text-center text-light">{ !search.search && "Recent"} Searches</h4>
                <div className="d-flex overflow-auto pb-2 scrollbar-hidden" style={{ justifyContent: width > 992 && "center" }}>
                  {search.search
                    ? <p className="recent-searches d-flex p-3 m-2">
                      <Icon icon={faSearch} className={"text-saffron"} />
                      <span className="text-light" >{search.search} <Icon icon={faXmark} className="ms-3 cursor-pointer" onClick={() => homesearch(({ tag: activeLink, search: null }))} /></span>
                    </p>
                    : ["Kedarnath", "Dev Deepawali", "Stays in vrindavan", "Akshardham", "Kumbh Mela", "Rameshwaram"].map((search, i) => <SearchCapsules name={search} />)
                  }</div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div className="top-destinations-container ">
        <div className="row mx-0 px-5 pt-5">
          <div className="col-md-8 p-0">
            <div className="top-heading">Top Destinations in India</div>
            <div className="top-destinations-subHeading mt-2">
              Making the Most of Your Travel Experience in 2024
            </div>
          </div>
        </div>

        <div className=" mt-4">
          <ul
            className="list-unstyled d-flex overflow-auto"
            style={{ scrollbarWidth: "none" }}
          >
            <ImageSlider slidesPerView={Math.fround(width / 410).toFixed(1)}>
              {locations.map((location, i) => (
                <SwiperSlide>
                  <li key={i} className="p-3">
                    <AccommodationCard data={location} />
                  </li>
                </SwiperSlide>
              ))}
              </ImageSlider>
          </ul>
        </div>
      </div>

      {/* location in mobile only */}
      <div className="mt-3 hidden-in-desktop ">
        <ul className="list-unstyled mobileScrollBar d-flex gap-3 px-3">
          <li >
             <Link to={`/search-result?city=nearby`} className="text-secondary">
                <div  className="rounded-circle" style={{ width: "75px", height: "75px" }} >
                  <img
                    src={Location}
                    className="w-100 h-100 rounded-circle"
                  />
                </div>
                <p className="mb-0 text-center">Near By</p>
             </Link>
            </li>
          {locations?.map((location, i) => (
            <li key={i}>
              <Link to={`/search-result?city=${location.name}`} className="text-secondary">
                <div
                  className=""
                  style={{ width: "75px", height: "75px", borderRadius: "50%" }}
                >
                  <img
                    src={location?.file?.Url}
                    className="w-100 h-100 "
                    alt=""
                    style={{ borderRadius: "50%" }}
                  />
                </div>
                <p className="mb-0 text-center">{location.name}</p>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      {/* location in mobile only */}

      <div className=" mt-4 ">
        <div className="d-flex top-heading-container p-4">
          <div className="top-heading heading-center">Quick Picks for you</div>
          <Link to={'/search-result'} className="view-all" style={{ width: "auto" }}>
            View More
          </Link>
        </div>
        <ul className="list-unstyled d-flex gap-3 mt-2 p-2  home-quick-pick-list mobileScrollBar">
            {propertyType?.map((property, i) => (
                <li key={i}>
                  <Link to={`/search-result?propertyTypeId=${property.id}`} className="quick-picks d-flex cursor-pointer" >
                    <div className="">
                      <img
                        className="recent-searches-icon"
                        src={location}
                        alt=""
                      />
                    </div>
                    <span className="font-16 text-nowrap text-saffron border-saffron">
                      { property.name }
                    </span>
                  </Link>
                </li>
              ))}
        </ul>

        <ul className="list-unstyled d-flex overflow-auto scrollbar-hidden">
          { hotels?.length > 3 && <ImageSlider 
            // slidesPerView={Math.fround(width / 410).toFixed(1)}
            breakpoints={hotels_breakpoints} 
            spaceBetween={15}
            loop={hotels?.length > 3} 
          >
            {hotels?.map((hotel, i) => (
              <SwiperSlide>
                <li className="p-1">
                  <div className="">
                    <PropertyCard data={hotel} />
                  </div>
                </li>
              </SwiperSlide>
            ))}
          </ImageSlider>}


            {hotels?.length <= 3 && hotels?.map((hotel, i) => (
                <li className="p-1">
                  <div className="property-card-container">
                    <PropertyCard data={hotel} />
                  </div>
                </li>
            ))}
        </ul>
      </div>

      <div className="mt-4 ">
        <div className="d-flex justify-content-between px-4">
          <div className="top-heading">Local guides near you</div>
          <Link to={'/guide'} className="view-all" style={{ width: "auto" }}>
            Explore more
          </Link>
        </div>

        {/* Guides  cards */}
        <div className="mt-4">
          <ul className="list-unstyled guide-Mobile-List d-flex overflow-auto scrollbar-hidden ">
            {guides?.slice(0,4)?.map((guide, i) => (
              <li key={i} className="p-2">
                {width > 768 ? <GuideCard data={guide} /> : <GuideCardMobile data={guide} />}
              </li>
            ))}
          </ul>
          <Link to={'/guide'} className="d-flex justify-content-center d-lg-none mb-5">
            <button className="secondary-btn ">Explore More</button>
          </Link>
        </div>
      </div>

          {/* Trending */}

      <div className="p-3">
        <div className="top-heading">Upcoming tours & events</div>
        <div className="top-destinations-subHeading mt-2">
          Making the Most of Your Travel Experience in 2024
        </div>
      </div>
      <div className='overflow-auto scrollbar-hidden'>
        <div className="d-flex ">
          <ImageSlider slidesPerView={Math.fround(width / ( width > 992 ? 950 : 420)).toFixed(1)}>
            {
              upcomingToursAndEvents?.map((tour, i) =>
                <div className='col-lg-8 col-md-12' >
                  <SwiperSlide>
                    <TrendingCard data={tour} />
                  </SwiperSlide>
                </div>
              )
            }
          </ImageSlider>
        </div>
      </div>

      {/* *****Blogs****** */}
      <section>
        <div className="row mx-0 p-lg-4 p-3 mt-4">
          <div className="col-md-8 p-0">
            <div className="top-heading">Latest Blog &amp; News</div>
            <div className="top-destinations-subHeading mt-2">
              Making the Most of Your Travel Experience in 2024
            </div>
          </div>
          <div className="col-md-4 d-flex justify-content-end">
            <Link to={'/blogs'} className="view-all w-50">Know More</Link>
          </div>
        </div>

        <div className=" p-lg-4 p-">
          <div className="d-flex overflow-auto scrollbar-hidden p-0 container">
            {blogs.map((blog, i) => (
              <div key={i} className="col-md-7 col-lg-3 ">
                <div className="m-2">
                  <BlogCard data={blog} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* offers */}
      <div className="offers">
        <div className="row mx-0 px-5 pt-5">
          <div className="col-md-8 p-0">
            <div className="top-heading">Offers Tailored For You</div>
          </div>
          <div className="col-md-4 d-flex justify-content-end">
            <Link to={'/blogs'} className="view-all w-50">Know More</Link>
          </div>
        </div>

        <div className="row  mx-0 my-5 ">
          <ul className="list-unstyled d-flex offers-card-list-mobile  mobileScrollBar">
            <li className="m-2">
              <div className="bg-dark rounded offers-card-container">
                <OfferCard data={"Get upto 15% off on your First Booking"} />
              </div>
            </li>

            <li className="m-2">
              <div className="bg-dark rounded offers-card-container">
                <OfferCard data={"Budget Friendly Homestays"} />
              </div>
            </li>
          </ul>

          <div className="col-md-6 d-flex justify-content-start sm-justify-content-end"></div>
        </div>
      </div>

      {modal.open && <LoginPopup open={modal.open} setOpen={setModal} />}

    </>
  );
};

export default HomePage;
